import gql from 'graphql-tag'

const listUsers = gql`
	fragment listUsers on UserConnection {
		items {
			id
			code
			name
		}
		cursors {
			hasNext
			hasPrevious
			before
			after
		}
		hasNextPage
		total
	}
`

export default gql`
query listUsers($filter: UserFilterArgs, $params: ListQueryArgs) {
	cashAssist {
		listUsers(filter: $filter, params: $params) {
			...listUsers
		}
	}
}
${listUsers}`
